import React from "react";
import { PanelEditTelegramGroup } from "../../../../UI/Groups/Telegram/Edit/PanelEditTelegramGroup";

const EditTelegramGroup = () => {
  return (
    <div>
      <PanelEditTelegramGroup />
    </div>
  );
};

export default React.memo(EditTelegramGroup);
